import React from 'react';
import { Box, Button } from '@mui/material';
import AppleIcon from '@mui/icons-material/Apple';
import ShopIcon from '@mui/icons-material/Shop';

const StoreButtons = ({ direction = 'row' }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', sm: direction }, 
        gap: 2,
        mt: 2
      }}
    >
      <Button
        variant="contained"
        color="secondary"
        size="large"
        startIcon={<AppleIcon />}
        sx={{
          px: 3,
          py: 1.2,
          fontWeight: 600,
          whiteSpace: 'nowrap',
          boxShadow: '0 4px 14px 0 rgba(58, 187, 201, 0.4)',
        }}
      >
        App Store
      </Button>
      <Button
        variant="contained"
        color="secondary"
        size="large"
        startIcon={<ShopIcon />}
        sx={{
          px: 3,
          py: 1.2,
          fontWeight: 600,
          whiteSpace: 'nowrap',
          boxShadow: '0 4px 14px 0 rgba(58, 187, 201, 0.4)',
        }}
      >
        Google Play
      </Button>
    </Box>
  );
};

export default StoreButtons; 